export function buildLocationValue(city, state) {
  if (!city && !state) return '';
  return [city, state, 'Colombia'].filter(Boolean).join(', ');
}

export function resolveGuestFilter(query, previousValue) {
  if (Object.prototype.hasOwnProperty.call(query || {}, 'guests')) {
    const value = Number(query.guests);
    return Number.isInteger(value) && value > 0 ? value : null;
  }
  // Opening a catalog tab is a new search, not a continuation of hidden filters.
  if (Object.prototype.hasOwnProperty.call(query || {}, 'mode')) return null;
  const previous = Number(previousValue);
  return Number.isInteger(previous) && previous > 0 ? previous : null;
}

export function formatTerritoryName(value) {
  return String(value || '')
    .toLocaleLowerCase('es-CO')
    .replace(/(^|[\s('-])([a-záéíóúüñ])/g, (match, prefix, letter) => `${prefix}${letter.toLocaleUpperCase('es-CO')}`)
    .replace(/\bD\.c\./g, 'D.C.');
}

export function normalizeTerritoryName(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleUpperCase('es-CO')
    .replace(/[^A-Z0-9Ñ]+/g, ' ')
    .replace(/^DEPARTAMENTO DE /, '')
    .trim();
}

export function buildRegisteredTerritories(locations, territoryCatalog) {
  const departments = (territoryCatalog && territoryCatalog.departments) || [];
  const grouped = new Map();

  (locations || []).forEach(location => {
    const stateKey = normalizeTerritoryName(location && location.state);
    if (!stateKey) return;
    const department = departments.find(item => normalizeTerritoryName(item.name) === stateKey);
    const stateName = department ? department.name : String(location.state).trim();
    const stateCode = department ? department.code : stateKey;
    if (!grouped.has(stateCode)) grouped.set(stateCode, { code: stateCode, name: stateName, municipalities: new Map() });

    const cityValue = String((location && location.city) || '').trim();
    if (!cityValue) return;
    const cityKey = normalizeTerritoryName(cityValue);
    const officialCities = department ? department.municipalities : [];
    const exact = officialCities.find(item => normalizeTerritoryName(item.name) === cityKey);
    const contained = exact || officialCities
      .filter(item => normalizeTerritoryName(item.name).length >= 4 && cityKey.includes(normalizeTerritoryName(item.name)))
      .sort((a, b) => normalizeTerritoryName(b.name).length - normalizeTerritoryName(a.name).length)[0];
    const city = contained || { code: `${stateCode}-${cityKey}`, name: cityValue };
    grouped.get(stateCode).municipalities.set(city.code, city);
  });

  return Array.from(grouped.values())
    .map(item => ({ ...item, municipalities: Array.from(item.municipalities.values()).sort((a, b) => a.name.localeCompare(b.name, 'es')) }))
    .sort((a, b) => a.name.localeCompare(b.name, 'es'));
}
